export const onlyLettersAndSpaces = /^[\u00C0-\u017Fa-zA-Z\s]*$/;
export const onlyNumbers = /^\d*$/;
export const phoneNumber = /^([-0-9()+ ]){2,}$/;
export const fullPhoneNumber = /^\+([-0-9()+ ]){2,}$/;

export const ssn = /^([0-9]{8})+-[0-9]{4}$/;
export const hprNumber = /^\d*$/;
export const streetName = /^[\u00C0-\u017Fa-zA-Z0-9\s,./]*$/;
export const streetNameWithDash = /^[-\u00C0-\u017Fa-zA-Z0-9\s,./]*$/;
export const stringYearOptional = /^$|^\d\d\d\d$/;

export const zipCodeOrEmpty = /($|^[0-9\s-]+$)/;
export const seOrgNumOrEmpty = /^$|^[0-9]{6}-[0-9]{4}$/;
